<template>
  <button type="button" class="btn-white">
    <i v-if="icon" :class="icon" />
    <span v-if="icon && label" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "whiteButton",
  props: ["label", "icon"],
};
</script>